// Main menu

$('[data-responsive-toggle]').on('toggled.zf.responsiveToggle', function(e){
	$('.c-top-bar').toggleClass("is-open");
	$('body').toggleClass('menu-open');
});

// Sticky
// var num = 200;

// $(window).bind('scroll', function () {
//     if ($(window).scrollTop() > num) {
//         $('.c-top-bar').addClass('c-top-bar--sticky');
//     } else {
//         $('.c-top-bar').removeClass('c-top-bar--sticky');
//     }
// });